import graphql__6f8b73c033e4e4eb0a15 from "./__generated__/ProfileEditionRouteQuery.graphql.js";import { Component } from "react";
import { graphql } from "react-relay";
import AppQueryRenderer from "../AppQueryRenderer";

import ProfileEdition from "../Profile/ProfileEdition";

class ProfileEditionRoute extends Component {
  render() {
    return (
      <AppQueryRenderer
        query={ProfileEditionRouteQuery}
        component={ProfileEdition}
        additionalProps={this.props}
      />
    );
  }
}

const ProfileEditionRouteQuery = graphql__6f8b73c033e4e4eb0a15;

export default ProfileEditionRoute;
